import { z } from 'zod';

/**
 * THE 1:1 FACE CHECK BEHIND A TYPED NUMBER. When an operator types a worker's
 * number, the device still compares the photo it takes against THAT worker's
 * templates. Sent only on MANUAL_ID punches (`FieldEventSchema`) and typed picks
 * (`FieldTransferSchema`); absent from older apps, which the server treats
 * exactly as before.
 *
 *   MATCH       the face agrees with the number typed
 *   BORDERLINE  it does not agree well enough — never counts until reviewed
 *   NO_TEMPLATE the worker has no face on file to compare against
 *
 * Its own file because field.schema.ts sits at its line budget.
 */
export const FieldVerifyResultSchema = z.enum(['MATCH', 'BORDERLINE', 'NO_TEMPLATE']);
export type FieldVerifyResult = z.infer<typeof FieldVerifyResultSchema>;

export const FieldManualVerifyShape = {
  verifyScore: z.number().min(0).max(1).optional(),
  verifyResult: FieldVerifyResultSchema.optional(),
};
